import "./scss/application.scss";
import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import { createRoutes } from "./routes";
import { fetchWorkItems } from "@/work-items-factory/index.js";
import store from "@/store/index.js";
const FontFaceObserver = require("fontfaceobserver");
Vue.use(VueRouter);
const body = document.getElementsByTagName("BODY")[0];
const html = document.querySelector("html");
export const eventBus = new Vue();
export const isMobileSafari =
  window.navigator.userAgent.match(/iPad/i) ||
  window.navigator.userAgent.match(/iPhone/i)
    ? true
    : false;
export const isSafari = window.safari !== undefined;
export { body, html };

var fontNormal = new FontFaceObserver("Europa", { weight: "normal" });
var fontBold = new FontFaceObserver("Europa", { weight: "bold" });
const isShadow = process.env.NODE_ENV === "shadow";

Promise.all([fontNormal.load(), fontBold.load()]).then(() => {
  fetchWorkItems.then(workItems => {
    store.commit("GET_WORK_ITEMS", workItems);
    const routes = createRoutes(workItems);
    const router = new VueRouter({
      //mode: isShadow ? "history" : "hash",
      mode: "hash",
      routes
    });
    router.afterEach(() => {
      eventBus.$emit("routeChange");
    });
    new Vue({
      el: "#app",
      store,
      router,
      render: h => h(App)
    });
  });
});
